export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SITE = {
  name: "Anna Zavarzina",
  brand: "Progressive Innovations LLC",
  title: "Organizational Transformations Consultant",
  tagline: "Transforming Strategy Into Results",
  email: "info@progressiveinn.com",
  linkedin: "https://www.linkedin.com/in/anna-zavarzina-spc6/",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    id: "assessment",
    number: "01",
    title: "Agile Transformation Assessment",
    summary:
      "A structured diagnostic of your delivery system, leadership alignment, and flow — with a clear, prioritized view of what's working and what isn't.",
    audience: "CIOs, COOs, and Heads of Transformation inheriting an in-flight or stalled change.",
    outcome:
      "A baseline you can defend to the board, plus the 3–5 interventions that will move the needle in the next 90 days.",
    span: "large",
  },
  {
    id: "leadership",
    number: "02",
    title: "Leadership Coaching & Advisory",
    summary:
      "One-to-one and team-level coaching for executives navigating organizational change, scaling product orgs, or rebuilding trust after a hard quarter.",
    audience: "CEOs, CTOs, VPs of Product, Engineering, and Delivery.",
    outcome:
      "Sharper decisions, calmer leadership rhythms, and a leadership team that pulls in the same direction.",
    span: "small",
  },
  {
    id: "workshops",
    number: "03",
    title: "Team & Executive Workshops",
    summary:
      "Working sessions for leadership teams and delivery groups — focused on alignment, operating model design, and unblocking real work in the room.",
    audience: "Executive teams, transformation offices, and cross-functional delivery groups.",
    outcome:
      "Decisions made, not just discussed. Teams leave with shared language and a concrete next step.",
    span: "small",
  },
  {
    id: "roadmap",
    number: "04",
    title: "Transformation Roadmap Development",
    summary:
      "A sequenced, realistic transformation plan — built around your business outcomes, constraints, and the change capacity your organization actually has.",
    audience: "Transformation sponsors and leaders accountable for measurable change.",
    outcome:
      "A 6–12 month roadmap your executive team can fund, defend, and execute against.",
    span: "small",
  },
  {
    id: "advisory",
    number: "05",
    title: "Ongoing Advisory & Retainer",
    summary:
      "A trusted thinking partner on call as your transformation unfolds — for the high-stakes calls, the difficult conversations, and the inflection points.",
    audience: "C-suite and senior leaders who want continuity and discretion.",
    outcome:
      "Fewer expensive missteps. Faster, more confident decisions. A steadier hand at the top.",
    span: "large",
  },
];

export const PROCESS = [
  {
    step: "01",
    name: "Discover",
    description:
      "We start with a focused conversation — your goals, the friction points, and what success looks like in 12 months.",
  },
  {
    step: "02",
    name: "Assess",
    description:
      "A structured look at delivery, leadership alignment, and flow. Quantitative where useful, qualitative where it matters.",
  },
  {
    step: "03",
    name: "Roadmap",
    description:
      "A practical, sequenced plan built around your business outcomes, change capacity, and constraints.",
  },
  {
    step: "04",
    name: "Support",
    description:
      "Hands-on advisory through the work — coaching leaders, unblocking teams, and adjusting the plan as reality changes.",
  },
];

export const OUTCOMES = [
  { metric: "Faster", label: "delivery cycles and shorter time-to-value" },
  { metric: "Clearer", label: "alignment between strategy and execution" },
  { metric: "Stronger", label: "leadership rhythms and decision-making" },
  { metric: "Measurable", label: "outcomes — not theatre, not frameworks" },
];

export const MEDIA = {
  heroBackground:
    "https://static.prod-images.emergentagent.com/jobs/89ebb0a4-31fe-44e3-a7f5-53694a556440/images/cab3910dcf8a4ae8c0db8ba38e73cc42ff981a75ecf290f40e031fec79af97f2.png",
  portrait:
    "https://customer-assets.emergentagent.com/job_delivery-strategy/artifacts/0m2hzhty_F778EF30-E531-49D3-A7CC-CE97C37B0132_1_102_o.jpeg",
  transformation:
    "https://static.prod-images.emergentagent.com/jobs/89ebb0a4-31fe-44e3-a7f5-53694a556440/images/10c31a63d476d34fd8b3aec91134de59bb136f786cfa54faba68e5a44a2646f7.png",
  architecture:
    "https://images.unsplash.com/photo-1665779736808-047a6bbf43a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmFsJTIwZGV0YWlscyUyMG1pbmltYWxpc218ZW58MHx8fHwxNzc5OTIxNDQ0fDA&ixlib=rb-4.1.0&q=85",
};
